<template>
  <div :class="[$style.downloadButtonBlock]">
    <BitButton type="secondary" is-fit-width @click="downloadFile">
      {{ data.title }}
    </BitButton>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { strapiFileParser } from '~/utils/strapiComponents/addStrapiData';
import type { ComponentInfoPageBlocksDownloadButton } from '~/types/infoPages';

const props = defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksDownloadButton>,
    default: () => ({}),
  },
});

const downloadFile = async () => {
  const response = (await $fetch(strapiFileParser(props.data.file).url, {
    method: 'get',
    responseType: 'blob',
  })) as any;

  const blob = new Blob([response], { type: 'application/pdf' });
  const link = document.createElement('a');

  link.href = URL.createObjectURL(blob);
  link.download = '7Bitcasino Terms and Conditions';
  link.click();
  URL.revokeObjectURL(link.href);
};
</script>
<style lang="scss" module src="./infoPageDownloadFileBlock.scss"></style>
